import LoginModule from '@/modules/login/LoginModule';

export default LoginModule;

